import { ActionWithPayload } from "@obg/ngrx-utils";

import { RECOMMENDED_GAMES_ACTION_TYPE } from "./recommended-games.action";
import { RecommendedGamesState } from "./recommended-games.model";

const INITIAL_STATE: RecommendedGamesState = {
	games: [],
};

export function recommendedGamesReducer(state = INITIAL_STATE, action: ActionWithPayload): RecommendedGamesState {
	switch (action.type) {
		case RECOMMENDED_GAMES_ACTION_TYPE.getAllSuccess: {
			return {
				...state,
				games: action.payload,
			};
		}

		case RECOMMENDED_GAMES_ACTION_TYPE.reset:
			return INITIAL_STATE;

		default:
			return state;
	}
}
